<template>
  <div
    class="grey darken-3 t-rounded t-shadow standard-step-add mt-1 mb-1"
    :style="`width: ${width};`"
    >
    <v-icon class="ml-1 mr-1">add</v-icon>
    <div>{{text}}</div>
  </div>
</template>
<script>
  export default {
    props: ['text', 'width']
  }
</script>
<style>
  .standard-step-add {
    height: 25px;
    display: flex;
    color: white;
    cursor: pointer;
  }
</style>
